module.exports = __webpack_public_path__ + "fonts/font.cf6a251.woff2";